import { useCallback } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const useCaptchaVerify = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.error("Execute recaptcha not yet available");
      return null;
    }

    return executeRecaptcha("login");
  }, [executeRecaptcha]);
  return { isReady: !!executeRecaptcha, handleReCaptchaVerify };
};
export default useCaptchaVerify;
